interface BackCaretArrowProps {
  className?: string;
  scale?: number;
  stroke?: string;
}

const BackCaretArrow = ({ className = '', scale = 1, stroke = 'var(--foreground)' }: BackCaretArrowProps) => {
  const width = 4 * scale;
  const height = 8 * scale;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 4 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.25 1.08398L0.75 4.00065L3.25 6.91732"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BackCaretArrow;
